import React from "react";
import { useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import "./AllSets.css"; // Import custom CSS for scrolling

export default function AllSets() {
  const userSets = useSelector((state) => state.userVocabulary.userSets); // Get the user's vocabulary sets
  const setsSignedUrls = useSelector((state) => state.sets.setsSignedUrls); // Get the signed URLs for the set images

  return (
    <Container className="mt-4">
      <Row className="mb-1">
        <h5>My Sets</h5>
      </Row>

      {/* Scrollable Vertical Container for xs Devices */}
      <Row className="d-xs-block d-sm-none scrolling-vertical">
        {userSets.map((set) => (
          <div
            className="card-container d-flex flex-column justify-content-center mb-3"
            key={set.setName}
          >
            <div className="card position-relative">
              <img
                src={setsSignedUrls[set.id]} // Replace with your image URL
                className="card-img-top"
                alt={set.setName}
              />
              <div className="card-img-overlay d-flex flex-column justify-content-end">
                <h5 className="card-title text-white">{set.setName}</h5>
                <p className="card-text text-white">
                  Words set · {set.words.length}{" "}
                  {set.words.length === 1 ? "word" : "words"}
                </p>
              </div>
            </div>
          </div>
        ))}
      </Row>

      {/* Regular Grid Layout for Larger Screens */}
      <Row className="d-none d-sm-flex">
        {userSets.map((set) => (
          <Col
            lg={4}
            md={6}
            sm={12}
            xs={12}
            className="d-flex flex-column justify-content-center mb-3"
            key={set.setName}
          >
            <div className="card position-relative">
              <img
                src={setsSignedUrls[set.id]} // Replace with your image URL
                className="card-img-top"
                alt={set.setName}
              />
              <div className="card-img-overlay d-flex flex-column justify-content-end">
                <h5 className="card-title text-white">{set.setName}</h5>
                <p className="card-text text-white">
                  Words set · {set.words.length}{" "}
                  {set.words.length === 1 ? "word" : "words"}
                </p>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
